import activityLogService from 'features/wells/overview/activityLog/helpers/activityLog.service';
import {
  ACTIVITY_LOG_ACTIONS,
  InitialFormValues,
} from 'features/wells/overview/activityLog/helpers/activityLog.constants';
import { NOTIFICATION_VARIANTS } from 'app/app.constants';

export const upsertActivityLog =
  (wellId, formValues, toggleDrawer) => (dispatch) => {
    const { activityLogId, ...activity } = formValues;

    const payload = activityLogService
      .upsertActivityLog(wellId, activity, activityLogId)
      .then(() => dispatch(filterActivityLogs(wellId, InitialFormValues)))
      .then(() => toggleDrawer());

    dispatch({
      type: ACTIVITY_LOG_ACTIONS.UPSERT_ACTIVITY_LOG,
      notification: {
        [NOTIFICATION_VARIANTS.ERROR]: activityLogId
          ? `Error updating ${activity.activityName}.`
          : `Error creating ${activity.activityName}.`,
        [NOTIFICATION_VARIANTS.INFO]: activityLogId
          ? `Updating ${activity.activityName}...`
          : `Adding ${activity.activityName}...`,
        [NOTIFICATION_VARIANTS.SUCCESS]: activityLogId
          ? `${activity.activityName} has been successfully updated!`
          : `${activity.activityName} has been successfully added!`,
      },
      payload,
    });
  };

export const getIntegrityManagementUsersByOrganization = () => (dispatch) => {
  const payload = activityLogService.getIntegrityUsersByOrganization();

  dispatch({
    type: ACTIVITY_LOG_ACTIONS.GET_INTEGRITY_MANAGEMENT_USERS_BY_ORGANIZATION,
    notification: {
      [NOTIFICATION_VARIANTS.ERROR]:
        'Error fetching integrity management users',
    },
    payload,
  });
};

export const filterActivityLogs = (wellId, filters) => (dispatch) => {
  const payload = activityLogService.filterActivityLogs(wellId, filters);

  dispatch({
    type: ACTIVITY_LOG_ACTIONS.SEARCH_ACTIVITY_LOGS,
    notification: {
      [NOTIFICATION_VARIANTS.ERROR]: 'Error fetching activity logs',
    },
    payload,
  });
};

export const filterFieldActivityLogs = (fieldId, filters) => (dispatch) => {
  const payload = activityLogService.filterFieldActivityLogs(fieldId, filters);

  dispatch({
    type: ACTIVITY_LOG_ACTIONS.SEARCH_FIELD_ACTIVITY_LOGS,
    notification: {
      [NOTIFICATION_VARIANTS.ERROR]: 'Error fetching activity logs',
    },
    payload,
  });
};

export const deleteActivityLog = (activityLogId, wellId) => (dispatch) => {
  dispatch({
    activityLogId,
    type: ACTIVITY_LOG_ACTIONS.DELETE_ACTIVITY_LOG,
    confirmationDialog: {
      title: 'Delete Activity Log',
      confirmButtonText: 'Delete',
      description: 'Are you sure you want to delete this Activity Log?',
    },
    notification: {
      [NOTIFICATION_VARIANTS.INFO]: 'Deleting Activity Log',
      [NOTIFICATION_VARIANTS.SUCCESS]: 'Activity successfully Deleted!',
      [NOTIFICATION_VARIANTS.ERROR]: 'Cannot delete Activity Log',
    },
    payload: () => {
      return activityLogService.deleteActivityLog(activityLogId).then(() => {
        dispatch(filterActivityLogs(wellId, InitialFormValues));
      });
    },
  });
};
